import { useState } from 'react'
import moment from 'moment'
import Head from 'next/head'
import Metadata from '../Metadata'
import BreakingNewsBanner from '../BreakingNewsBanner'
import Byline from './Byline'
import Hero from './Hero'
import RelatedStories from './RelatedStories'
import SharingIcons from './SharingIcons'
import Story from './Story'
import style from '../../styles/components/story/story'

const StoryDetails = ({ story, metadata, banner }) => {
  const [viewTranscript, setViewTranscript] = useState(false)

  const storyWasUpdated = story.publishedAt && story.updatedAt && story.publishedAt !== story.updatedAt
  const hasHeroVideo = !!story?.videoFile
  const showBreakingNewsBanner = banner?.title && banner?.slug !== story?.slug

  return (
    <>
      <Head>
        <link rel='amphtml' href={`https://cheddar.com/amp/media/${story?.slug}`} />
      </Head>
      <Metadata metadata={metadata} />
      {showBreakingNewsBanner && <BreakingNewsBanner banner={banner} />}
      <div className='article-container'>
        <div className='category-text'>{story.categories?.[0]?.name?.toUpperCase()}</div>
        <div className='article-title'>
          {viewTranscript && <span>Transcript: </span>}
          {story.title}
        </div>
        <div className='byline-container'>
          <div className='timeline'>
            {moment(story.publishedAt).format('MMM D, YYYY hh:mm a')}
            {storyWasUpdated && <i>{` • Updated ${moment(story.updatedAt).fromNow()}`}</i>}
          </div>
          <Byline authors={story.authors} />
        </div>
        <Hero story={story} />
        {!hasHeroVideo && <div className='attribution'>{story.thumbnailAttribution}</div>}
        <SharingIcons story={story} hasHeroVideo={hasHeroVideo} viewTranscript={viewTranscript} setViewTranscript={setViewTranscript} />
        <Story story={story} viewTranscript={viewTranscript} />
        {story.categories?.length > 0 && <RelatedStories story={story} />}
      </div>
      <style jsx>{style}</style>
    </>
  )
}

export default StoryDetails
